import { get } from 'helpers/apiHelpers';
import types from 'helpers/constants';

export const fetchDeliveryTypes = () => dispatch =>
  // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
  get('/delivery-types', { pagination: false }).then(response => {
    dispatch({
      type: types.FETCH_DELIVERYTYPES,
      payload: {
        deliveryTypes: response['hydra:member'],
      },
    });
  });
